import { gql } from "@apollo/client"

const GET_STUDENTS_WITHOUT_GUARDIANS = gql`
  query ($input: StudentsWithoutGuardiansInput!) {
    studentsWithoutGuardians(input: $input) {
      id
      forename
      surname
    }
  }
`

export { GET_STUDENTS_WITHOUT_GUARDIANS }
